export const MASKS = {
    /** Sólo letras y espacio */
    B: {
        pattern: new RegExp('\[a-zA-Z \]'),
        optional: true
    },
    /** Alfanumérico */
    C: {
        pattern: new RegExp('\[a-zA-Z0-9\]'),
        optional: true
    },
};
